import styled from 'styled-components'

export const RowGapWrapper = styled.div<{ rowGap: number }>`
  display: flex;
  flex-direction: column;
  row-gap: ${({ rowGap }) => `${rowGap}px`};
`
